import { Serialize } from "@trpc/server/dist/shared/internal/serialize";
import { paths } from "./generated-schema-v0";
import { has, get } from "lodash";
import { TablesApiError } from "server/services/errors";

// we're not sure why typescript requires this extends unknown ? Any : never...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Any = any;

export type PickRequestBody<
  Path extends keyof paths,
  Method extends keyof paths[Path] extends unknown ? Any : never
> = paths[Path][Method]["requestBody"]["content"]["application/json"];

export type PickRequestQuery<
  Path extends keyof paths,
  Method extends keyof paths[Path] extends unknown ? Any : never
> = paths[Path][Method]["parameters"]["query"];

export type PickResponseBody<
  Path extends keyof paths,
  Method extends keyof paths[Path] extends unknown ? Any : never
> = paths[Path][Method]["responses"]["200"]["content"]["application/json"];

// ↑ Everything above was copied from tablesui
// ↓ Everything below is our own

export type PickResponses<
  Path extends keyof paths,
  Method extends keyof paths[Path] extends unknown ? Any : never
> = paths[Path][Method]["responses"];

export function isType<T extends Record<string, any>>(
  object: Record<string, any>,
  property: string,
  check?: (value: unknown) => boolean
): object is Serialize<T> {
  if (check) {
    return check(get(object as T, property));
  }
  return has(object as T, property);
}

export function isTablesApiError(
  object: Record<string, any> | Error | undefined
): object is Serialize<TablesApiError> {
  if (typeof object === "undefined") return false;
  return isType<TablesApiError>(
    object,
    "code",
    (code) => typeof code === "string" && code.startsWith("tables:")
  );
}

export function isTooManyFieldsResponse(e: Serialize<TablesApiError>): boolean {
  return isTablesApiError(e) && e.code === "tables:limits:too_many_fields";
}

export function isTooManyTablesResponse(e: Serialize<TablesApiError>): boolean {
  return isTablesApiError(e) && e.code === "tables:limits:too_many_tables";
}

export function isTooManyRecordsResponse(
  e: Serialize<TablesApiError>
): boolean {
  return isTablesApiError(e) && e.code === "tables:limits:too_many_records";
}
